// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"613915b2","905":"d3915d91"}[chunkId] + ".chunk.js";
};